<template>
    <el-row>
        <el-form :model="profitForm"
                 ref="profitRef"
                 :rules="rules"
                 addAction="/businessIntranet/refundBusinessProfit.action"
                 editAction="/businessIntranet/refundBusinessProfit.action"
                 label-width="150px"
                 style="width:40%"
                 v-form>

          <el-form-item label="扣减类型:" prop="type">
            <el-select v-model="profitForm.type">
              <el-option label="提现" :value="15" ></el-option>
              <el-option label="用户退款扣除" :value="16"></el-option>
            </el-select>
          </el-form-item>

            <el-form-item label="扣减收益(元)：" prop="totalMoney">
                <el-input type="number" v-model="profitForm.totalMoney"  placeholder="请输入扣减收益(元)"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary">确定</el-button>
                <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import EmployeeSelect from '@/components/EmployeeSelect'

export default {
  name: 'refundBusinessProfit',
  extends: BasicPager,
  components: { EmployeeSelect },
  data: function () {
    let checkDecima = (rule, value, callback) => {
      if (value < 0) {
        return callback(new Error('请填写大于0的数值'))
      }

      let match = (value + '').match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        return callback(new Error('小数点只能保留两位哦！'))
      }
      callback()
    }
    return {
      rules: {
        totalMoney: [{
          required: true,
          message: '请输入扣减收益金额'
        },
        { validator: checkDecima, trigger: 'blur' }
        ]
      },
      profitForm: {
        businessId: null,
        type : 15,
        totalMoney: null,

      }
    }
  },
  created () {
    this.profitForm.businessId = this.$route.query.businessId
  },
  methods: {
    onFilterParams: function (params) {
      params.totalMoney = parseInt(params.totalMoney * 100)
    },
    onSelectInfo: function (dataInfo) {

    }
  }

}
</script>

<style scoped>

</style>
